import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import AtomPresale from "../../components/presale/atom-presale";

const PresalePage: React.FC = () => {
  useEffect(() => {
    document.title = "Atom Presale | Atom Foundation";
  }, []);

  return (
    <Fragment>
      <div className="lab-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <AtomPresale />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default PresalePage;
